import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData } from 'src/utils/axios/serverHelper';
import { BankAcctDto } from "src/utils/bank/bankacctDto";

const baseUrl = `${config.apiUrl}/bankaccount`;

//조직 조회
export const getBankacctList = async (searchText?: string) => {
  const url = `${baseUrl}/modal`

  return await getData<ResponseDto<BankAcctDto[]>>(url, searchText ? {
    params: {
      searchText
    }
  } : undefined);
}